module.exports = __webpack_public_path__ + "media/en_au_s3_Kiara.e940625e.oga";